import React, { Component } from "react";
import { Link } from "react-router-dom";

class SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconbox: [
        {
          id: 1,
          icon: "autora-icon-quality",
          title: "VLASTITI PROIZVODI",
          text: "NAŠ PLAN - dva projekta godišnje.💪 Netko bi rekao vrlo ambiciozno, no mi zadajemo ciljeve koji su realni i ostvarivi.",
        },
        {
          id: 2,
          icon: "autora-icon-time",
          title: "ONSITE R&D",
          text: "NAŠ CILJ - Inovativni proizvodi i usluge, promišljanje načina na koji korisnicima aplikacija možemo olakšati svakodnevni život, uštedjeti vrijeme i osigurati ugodno korisničko iskustvo.",
        },
        {
          id: 3,
          icon: "autora-icon-author",
          title: "MULTIDISCIPLINARNI TIM",
          text: "KAKO? - Visokomotivirani tim s fokusom na rad, znanje i aktivno sudjelovanje u sim procesima. Uz širok spekatar vještina i iskusno vođenje rezultati su neizbježni!",
        },
      ],
      history: [
        {
          id: 1,
          content: [
            {
              id: 1,
              year: "01/2021.",
              text: "Osnovana je tvrtka CityX Apps doo. Osnovna ideja je bila unapređenje područja iz domene smart city",
              classnames: "flat-content-wrap",
              color: "black",
            },
            {
              id: 2,
              year: "4/2023.",
              text: "Plan za puštanje aplikacije CityX Tour&Pass u fazu eksperimentalnog rada",
              classnames: "flat-content-wrap",
              color: "silver",
            },
          ],
        },
        {
          id: 2,
          content: [
            {
              id: 1,
              year: "03/2022.",
              text: "Nakon više od godinu dana razvoja aplikacija CityX App puštena u probni rad/testiranje",
              classnames: "flat-content-wrap pd26",
              color: "black",
            },
            {
              id: 2,
              year: "10/2022",
              text: "Plan za izlazak naše treće aplikacije - funkcionalni prototip sportske aplikacije pod nazivom Sportter!",
              classnames: "flat-content-wrap pd26",
              color: "silver",
            },
          ],
        },
      ],
      accordions: [
        {
          id: 1,
          classnames: "accordion-item active",
          title: "our mission",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        },
        {
          id: 2,
          classnames: "accordion-item",
          title: "our vision",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        },
        {
          id: 3,
          classnames: "accordion-item",
          title: "our technology",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        },
      ],
    };
  }
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={61}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-headings style-1 clearfix">
            <h2 className="heading">
              UPOZNAJTE CITY<b>X</b>&#8482; APPS
            </h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p className="sub-heading  margin-top-28 margin-right-12">
              CityX Apps mlada je tvrtka osnovana 2021. g. s vizijom razvoja
              naprednih visokotehnoloških rješenja namijenjenih lokalnim
              sredinama. Naša mjerna jedinica je grad, a centar naše pažnje
              pojedinac - naš korisnik. Naša vizija, stručnost i interesi vezani
              su uz područja upravljanja gradom, digitalizacije u sportu, i to
              na bazičnoj razini, inovacijama u turizmu, javnom prijevozu i
              zelenim tranzicijama. Zanima nas kako brzo prenositi informacije i
              okupiti korisnike sve do razine ulice pa čak i jedne zgrade.
              Tomislav Krnić, osnivač CityX-a, okupio je vrhunske
              multidisciplinarne suradnike te spojio iskustvo "sijedih glava" i
              "mladih lavova". S razlogom imamo velike ambicije i planove u
              narednom razdoblju iznimnih tranzicijskih izazova jer su, kako se
              pokazalo, izazovna vremena uvijek stvarala jake kompanije.
              <br />
              "We choose to go to the Moon in this decade and do the other
              things, not because they are easy, but because they are hard." -
              John F. Kennedy
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={28}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-row gutter-15 clearfix">
            {this.state.iconbox.map((data) => (
              <div className="col span_1_of_4" key={data.id}>
                <div
                  className="themesflat-content-box clearfix"
                  data-margin="0 0px 0 0px"
                  data-mobilemargin="0 0 0 0"
                >
                  <div className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color border-light padding-inner pd33 style-1 clearfix">
                    <div className="icon-wrap">
                      <i className={data.icon} />
                    </div>
                    <div className="text-wrap">
                      <h5 className="heading">
                        <Link to="#">{data.title}</Link>
                      </h5>
                      <div className="sep clearfix" />
                      <p className="sub-heading">{data.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={45}
            data-mobile={35}
            data-smobile={35}
          />

          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">OVAKO JE TO BILO</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={24}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-row separator drank clearfix">
            {this.state.history.map((data) => (
              <div className="span_1_of_6 separator-solid" key={data.id}>
                {data.content.map((contents) => (
                  <div className={contents.classnames} key={contents.id}>
                    <div className="title" style={{ color: contents.color }}>
                      {contents.year}
                    </div>
                    <p style={{ color: contents.color }}>{contents.text}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default SiteContent;
